<template>
  <!-- ============================================================== -->
  <!-- Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <aside class="left-sidebar color-sidebar-s" :class="!showSidebar ? 'collapse-sidebar' : ''">
    <!--
    <div class="sidebar-profile" v-if="showSidebar">
      <div class="row">
        <div class="col-3">
          
            <img
              class="avatar"
              src="../../assets/images/users/profile.jpg"
              alt="user"
              style="width: 42px !important;"
            />
          
        </div>
        <div class="col-9">
          <a href="#/profile">
            <b> BKPSDM PROLAP</b>
            <p>prolap@bkpsdm.com</p>
          </a>
        </div>
      </div>
    </div>
  -->
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar" :class="!showSidebar ? 'mini-sidebar' : ''">
      <!-- Sidebar navigation-->
      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li class="nav-small-cap"> <span> Dashboard </span></li>
          <li> 
            <a href="#/dashboard"> 
               <fa-icon class="md-size-1x mr-3" icon="desktop"></fa-icon>
              <span class="hide-menu"> Dashboard  Utama</span> 
            </a> 
          </li>
           <li> 
            <a href="#/prolap/pohon"> 
               <fa-icon class="md-size-1x mr-3 " icon="sitemap"></fa-icon>
              <span class="hide-menu"> 9 Box Pemetaan </span> 
            </a> 
          </li>
           <li class="nav-small-cap"> <span> Statistik </span></li>
           <li> 
            <a href="#/prolap/statistikKinerja"> 
               <fa-icon class="md-size-1x mr-3" icon="chart-bar"></fa-icon>
              <span class="hide-menu"> Simulasi Suksesi </span> 
            </a> 
          </li>
           
           <li> 
            <a href="#/prolap/statistikProgram"> 
               <fa-icon class="md-size-1x mr-3" icon="chart-line"></fa-icon>
              <span class="hide-menu"> Analisis Kinerja </span> 
            </a> 
          </li>
           <li> 
            <a href="#/prolap/statistikAnggaran"> 
               <fa-icon class="md-size-1x mr-3" icon="chart-area"></fa-icon>
              <span class="hide-menu"> Analisis Prilaku 360 </span> 
            </a> 
          </li>

         
          <li class="nav-small-cap"> <span> Data Potensial </span></li>
          <li> 
            <a href="#/prolap/renstra"> 
               <fa-icon class="md-size-1x mr-3" icon="server"></fa-icon>
              <span class="hide-menu"> Peminatan </span> 
            </a> 
          </li>
          <li> 
            <a href="#/prolap/realisasi"> 
               <fa-icon class="md-size-1x mr-3" icon="share-alt"></fa-icon>
              <span class="hide-menu"> Assesment  </span> 
            </a> 
          </li>
           <li> 
            <a href="#/prolap/evaluasi"> 
               <fa-icon class="md-size-1x mr-3 " icon="calendar-alt" ></fa-icon>
              <span class="hide-menu"> Pendidikan & Pelatihan </span> 
            </a> 
          </li>
           <li> 
            <a href="#/prolap/laporan"> 
               <fa-icon class="md-size-1x mr-3" icon="copy"></fa-icon>
              <span class="hide-menu"> Quesioner </span> 
            </a> 
          </li>
          
         
        </ul>
      </nav>
      <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
  </aside>
  <!-- ============================================================== -->
  <!-- End Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState({
      showSidebar: state => state.showSidebar,
    //  menuItem: state => state.menuItem
    })
  },
  data() {
    return {
        menuItem : [] 
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    ...mapMutations({
     // toggleDropdown: "toggleDropdown"
    }),
     toggleDropdown(index) {
      this.menuItem[index].collapsed = !this.menuItem[index].collapsed;
    },
    fetchData() {

            this.$store.dispatch('getData',{
                url :  'api/site/apimenu?f=vue' 
            }) .then(response => {
                 this.menuItem  = response.data.data
            }).catch((error) => {
                alert(error)
            }) 

       
    }
  }
};
</script>

<style scoped>
.collapse-sidebar {
  width: 70px;
}
.collapse-sidebar #sidebarnav > li > a.has-arrow:after {
  display: none;
}
.svg-inline--fa {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Sidebar.vue